<div class="row mb-2">
  <div class="col-auto">
    <p class="dx-label pe-1">Last Saved Version:</p>
    <p class="dx-texteditor d-inline-block">
      {{ lastPublishedVersion() | empty }}
    </p>
  </div>

  <div class="col-auto"><i class="dx-icon dx-icon-to"></i></div>

  <div class="col-auto">
    <p class="dx-label pe-1">Document Version:</p>
    <p
      class="dx-texteditor d-inline-block"
      [innerHTML]="fileVersionSig() | fileVersionByChangedNumber: changedVersionNumberSig()"
    ></p>
  </div>
</div>

<div class="row align-items-center">
  <p class="dx-label col-auto">Version Change:</p>
  <dx-radio-group
    class="ag-radio-group col-auto"
    [items]="versionChangeLookup"
    [valueExpr]="LookupKeys.value"
    [displayExpr]="LookupKeys.description"
    [layout]="'horizontal'"
    stylingMode="outlined"
    [elementAttr]="{ class: 'ag-group__box-button-hidden pb-btn dx-button-mode-outlined dx-button-default'}"
    [value]="selectedVersionSig()"
    [disabled]="inProgress()"
    (onValueChanged)="onVersionChange($event)"
  ></dx-radio-group>
</div>
